import styled from 'styled-components';

export const BlocContent = styled.p`
  vertical-align: center;
  height: 2.4rem;
  display: flex;
  align-items: center;

  svg {
    color: var(--select-border-color);
    width: 1.6rem;
    height: 1.6rem;
    margin-left: 0.4rem;
  }
`;

export const Bloc = styled.div`
  padding: 0.8rem;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;

  &[data-row='true'] {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  &:not(:first-child) {
    border-top: 1px solid var(--content-border-color);
  }

  &:hover,
  &:focus-visible {
    background-color: var(--color-grayscale-arsenic);
    cursor: pointer;

    & div {
      color: var(--color-grayscale-white);
    }

    svg {
      stroke: var(--color-grayscale-white);
    }
  }
`;
